// One lowercased blob per parcel covering every criterion the "Find a parcel" box (LeftRail) and
// the ⌘K command palette's Enter handler (SiteMapApp) advertise, so the placeholder
// ("Lot, address, buyer, model, phase, status…") is honest. Lives in its own pure module (the
// Parcel TYPE comes from the node-testable joinCore, no Airtable SDK import) so the harness can
// import the REAL function — importing it from LeftRail pulls in @airtable/blocks, which is not
// node-safe at import time.
import type { Parcel } from './joinCore';

export const searchHaystack = (p: Parcel): string => [
  p.name, p.blockLot, p.block, p.lot,                                  // lot
  p.unit?.name, p.unit?.version, p.unit?.pkg, p.unit?.orientation,     // unit
  p.unit?.buyer, p.buyersAll,                                           // buyer (ALL units on the lot)
  p.model, p.unit?.model,                                               // model
  p.geo.phase, p.masterPhase, p.subPhase, p.unit?.concurrency,          // phase
  p.salesBucket, p.unit?.contractStatusLive, p.unit?.contractStatus, p.unit?.ghlContractStatus,
  p.buildStatus, p.unit?.buildStatus, p.buildPhase,                     // build status
  p.permitNumber, p.permitStatus, p.urgencyBand, p.closeoutStage, p.actionStatus, // permit/closeout status
  p.address, p.newParcelNumber,                                        // address / county parcel #
].map(v => (v == null ? '' : String(v))).join('  ').toLowerCase();
